import { makeStyles, withStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const {
	LIGHT_GREY,
	GREY,
	LIGHT_GRAY_SHADE,
	FONT_COLOR,
	TOGGLE_ACTIVE,
	WHITE,
	PURPLE,
	BLACK,
	DISABLED,
	HOVER_GRAY_SHADE,
	DARK_PURPLE,
	BACK_BTN,
	BORDER_COLOR,
	ALERT_COLOR,
	ALERT_FONT_COLOR,
	WARNING_TEXT_COLOR
} = colors;
import { Bogle_Regular, Bogle_Medium, Bogle_Light, Space_Between } from 'constants/constant';
import { LinearProgress } from '@material-ui/core';

const dashboardStyles = makeStyles((theme) => ({
	iconColor: {
		color: BLACK
	},
	noReport: {
		minWidth: '100vw',
		minHeight: '160px',
		fontSize: '24px',
		fontWeight: '400',
		lineHeight: '24px'
	},
	highlightRow: {
		backgroundColor: HOVER_GRAY_SHADE
	},
	imageIcon: {
		color: GREY
	},
	filterIcon: {
		'&:hover': {
			cursor: 'pointer',
			background: LIGHT_GRAY_SHADE
		}
	},
	containerHeight: {
		height: '100vh',
		width: '100vw',
		position: 'fixed'
	},
	content: {
		display: 'flex',
		justifyContent: Space_Between,
		padding: '0px 24px',
		alignItems: 'center',
		width: '100vw'
	},
	search: {
		position: 'relative',
		borderRadius: theme.shape.borderRadius,
		color: GREY,
		marginLeft: theme.spacing(1),
		width: (P) => (P.isSmallScreen ? 'auto' : '328px'),
		background: LIGHT_GRAY_SHADE,
		border: `1px solid ${LIGHT_GREY}`,
		display: 'flex',
		justifyContent: Space_Between
	},
	searchIcon: {
		padding: theme.spacing(0, 2),
		height: '100%',
		color: GREY,
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& .MuiSvgIcon-root': {
			width: '18px'
		}
	},
	crossIcon: {
		color: GREY,
		display: 'flex',
		alignItems: 'center',
		marginRight: '24px',
		'& .MuiSvgIcon-root': {
			width: '18px'
		}
	},
	input: {
		padding: theme.spacing(1, 1, 1, 0),
		paddingLeft: `calc(1em + ${theme.spacing(3)}px)`,
		height: '30px',
		fontFamily: Bogle_Regular,
		fontSize: '14px',
		width: 220,
		marginLeft: '8px'
	},
	tabsIndicator: {
		height: 4,
		borderRadius: [[100, 100, 0, 0]],
		color: GREY,
		width: '160px !important'
	},
	tabsRoot: {
		borderBottom: `1px solid #E3E4E5`,
		minHeight: 22,
		height: 43.5,
		// width: (P) => `${P.show ? 'calc(100vw - 420px)' : 'calc(100vw - 60px)'}`,
		marginTop: '10px',
		marginBottom: '10px'
	},
	tabRoot: {
		color: GREY,
		textTransform: 'capitalize !important',
		minHeight: 24,
		fontFamily: 'Bogle-Regular !important',
		fontSize: '18px !important',
		height: '100% !important'
	},
	tableContainer: {
		width: 'calc(100vw - 48px)',
		padding: '0 24px',
		overflowX: 'unset',
		overflowY: 'auto',
		'& .MuiTableCell-stickyHeader': {
			backgroundColor: WHITE
		}
	},
	table: {
		width: 'calc(100vw - 48px)',
		border: '0px',
		tableLayout: 'fixed'
	},
	mobileTable: {
		width: '100%',
		border: '0px'
	},
	tableRow: {
		borderBottom: `1px solid ${LIGHT_GRAY_SHADE}`,
		'&:hover': {
			cursor: 'pointer',
			background: HOVER_GRAY_SHADE
		}
	},
	tableCell: {
		border: '0px'
	},
	prevTableCell: {
		color: FONT_COLOR,
		height: (P) => (P.isSmallScreen ? '24px' : '56px'),
		fontSize: (P) => (P.isSmallScreen ? '14px' : '18px'),
		fontFamily: Bogle_Light
	},
	newTableCell: {
		color: FONT_COLOR,
		height: (P) => (P.isSmallScreen ? '24px' : '56px'),
		fontSize: (P) => (P.isSmallScreen ? '12px' : '18px'),
		fontFamily: Bogle_Medium
	},
	reportName: {
		width: '456px',
		position: 'relative'
	},
	bullet: {
		position: (P) => (P.isSmallScreen ? 'absolute' : 'relative'),
		marginLeft: '4px'
	},
	sortLabel: {
		marginBottom: 5,
		color: FONT_COLOR,
		opacity: 'unset !important'
	},
	menuItems: {
		display: 'flex',
		alignItems: 'start',
		color: FONT_COLOR,
		fontSize: '16px',
		'&:hover': {
			background: TOGGLE_ACTIVE
		}
	},
	menuItemIcon: {
		minWidth: '40px',
		color: '#6D6E71'
	},
	backdrop: {
		zIndex: 999,
		backgroundColor: WHITE,
		color: PURPLE,
		opacity: '0.8 !important'
	},
	container: {
		padding: '16px'
	},
	tittlePadding: {
		padding: '16px 16px 8px 16px'
	},
	dialogTitle: {
		fontSize: 22,
		fontFamily: Bogle_Medium,
		color: FONT_COLOR
	},
	actionBtnPadding: {
		padding: '8px 16px 16px 16px'
	},
	button: {
		height: 40,
		width: `76px !important`
	},
	buttonLabel: {
		fontSize: '14px',
		fontWeight: 400,
		color: WHITE,
		fontFamily: Bogle_Medium,
		cursor: 'pointer'
	},
	drawerContainer: {
		width: '360px',
		overflowY: 'scroll',
		marginBottom: '122px'
	},
	backButton: {
		padding: '8px 4px 8px 12px',
		color: BACK_BTN
	},
	crossButton: {
		padding: '4px 4px 4px 4px',
		color: BACK_BTN
	},
	drawerTitle: {
		fontSize: '24px',
		fontFamily: Bogle_Regular,
		color: BLACK,
		display: 'inline'
	},
	drawerContent: {
		padding: '16px'
	},
	darwer: {
		width: '328px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: Space_Between
	},
	value: {
		fontSize: '16px',
		fontFamily: Bogle_Regular,
		color: FONT_COLOR
	},
	key: {
		fontSize: '16px',
		fontFamily: Bogle_Medium,
		color: DISABLED,
		paddingBottom: '8px'
	},
	detail: {
		padding: '12px 0px'
	},
	smallScreen: {
		width: '328px',
		display: 'flex',
		alignItems: 'center'
	},
	myCustomStyles: {
		border: '1px solid red',
		height: '48px'
	},
	tableRowOuter: {
		height: '24px',
		padding: '8px 4px'
	},
	rootTableRowTotalRow: {
		height: '40px'
	},
	tableRowOInner: {
		height: (P) => (P.isSmallScreen ? '24px' : '56px')
	},
	tableRowMobile: {
		borderBottom: `1px solid ${LIGHT_GRAY_SHADE}`,
		'&:hover': {
			cursor: 'pointer'
		}
	},
	rootTableRowMobile: {
		height: '48px'
	},
	rootTotalTableRowMobile: {
		height: '56px'
	},
	rootTableRowMobileName: {
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		whiteSpace: 'nowrap'
	},
	rootTableRowMobileSec: {
		fontSize: 10
	},
	prevTableCellSmall: {
		color: FONT_COLOR,
		height: '24px',
		fontSize: 10,
		fontFamily: Bogle_Light,
		verticalAlign: 'top'
	},
	newTableCellSmall: {
		color: FONT_COLOR,
		height: (P) => (P.isSmallScreen ? '24px' : '56px'),
		fontSize: 10,
		fontFamily: Bogle_Medium,
		fontWeight: 500
	},
	errorContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100vw',
		height: 'calc(100vh - 128px)'
	},
	refresh: {
		color: BLACK
	},
	buttonContainer: {
		maxHeight: '88px',
		height: 'auto',
		textAlign: 'center',
		padding: '16px',
		borderTop: `1px solid ${LIGHT_GREY}`,
		position: 'fixed',
		bottom: 0,
		zIndex: 999,
		width: '336px',
		background: WHITE
	},
	drawerButton: {
		textTransform: 'unset',
		fontSize: '16px',
		fontWeight: 600,
		fontFamily: Bogle_Regular,
		border: '1px solid',
		width: '328px',
		height: '40px',
		'&:disabled': {
			color: WHITE,
			backgroundColor: LIGHT_GREY
		},
		borderRadius: '20px'
	},
	downloadButton: {
		color: WHITE,
		background: PURPLE,
		marginBottom: '8px',
		'&:hover': {
			color: WHITE,
			background: DARK_PURPLE
		}
	},
	editButton: {
		color: PURPLE,
		background: WHITE,
		'&:hover': {
			color: PURPLE,
			background: TOGGLE_ACTIVE
		}
	},
	deleteReport: {
		fontSize: '14px',
		paddingLeft: '16px',
		lineHeight: '24px',
		color: GREY,
		backgroundColor: HOVER_GRAY_SHADE
	},
	menuBorder: {
		borderTop: `1px solid ${LIGHT_GREY}`,
		'&:hover': {
			borderTop: '0px'
		}
	},
	backIcon: {
		marginLeft: '-8px',
		marginRight: '8px'
	},
	text: {
		fontFamily: Bogle_Regular,
		color: FONT_COLOR,
		fontSize: '14px',
		minHeight: '112px'
	},
	autoComplete: {
		fontSize: '14px',
		color: GREY
	},
	filterCircle: {
		borderRadius: '50%',
		fontSize: '12px !important',
		lineHeight: '0.7',
		width: 8,
		height: 8,
		padding: 4,
		background: TOGGLE_ACTIVE,
		color: PURPLE,
		fontWeight: 500,
		textAlign: 'center'
	},
	charterOnly: {
		marginLeft: '10px',
		marginTop: '5px',
		fontSize: '14px',
		color: FONT_COLOR
	},
	metadataFilters: {
		padding: '8px 0'
	},
	metadataFilterBussName: {
		color: FONT_COLOR,
		fontSize: '16px',
		display: 'flex',
		fontFamily: Bogle_Regular,
		paddingBottom: '8px'
	},
	metadataFilterConditionValue: {
		color: GREY,
		fontSize: '12px',
		fontFamily: Bogle_Regular,
		wordBreak: 'break-all',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		display: '-webkit-box',
		'-webkit-line-clamp': 2,
		'-webkit-box-orient': 'vertical'
	},
	metadataFilterExpanded: {
		color: GREY,
		fontSize: '12px',
		fontFamily: Bogle_Regular,
		wordBreak: 'break-all',
		overflow: 'auto',
		maxHeight: '75px'
	},
	metadataFilterCondition: {
		fontWeight: 'bold'
	},
	metadataFilterShowBtn: {
		color: PURPLE,
		fontWeight: 'bold',
		cursor: 'pointer',
		fontSize: '12px',
		float: 'right'
	},
	showAlertForExpiringReport: {
		margin: '24px',
		marginBottom: '0px',
		border: `1px solid ${BORDER_COLOR}`,
		borderLeftWidth: '4px',
		backgroundColor: `${ALERT_COLOR} !important`,
		color: ALERT_FONT_COLOR,
		height: '36px',
		padding: '0px 16px !important',
		'& .MuiAlert-message': {
			display: 'flex',
			width: '100%'
		},
		'& .MuiSvgIcon-root': {
			color: ALERT_FONT_COLOR,
			fontSize: '16px',
			alignSelf: 'center'
		}
	},
	showAlertForSpaceFull: {
		margin: '8px 24px 24px 24px',
		marginBottom: '0px',
		borderLeftWidth: '4px',
		backgroundColor: `#FCE8E9 !important`,
		color: WARNING_TEXT_COLOR,
		height: '36px',
		padding: '0px 16px !important',
		'& .MuiAlert-message': {
			width: '100%',
			display: 'flex'
		},
		'& .MuiSvgIcon-root': {
			color: ALERT_FONT_COLOR
		}
	},
	itemShareMsg: {
		border: `1px ${PURPLE} solid`,
		margin: '16px 16px 0px 16px',
		marginBottom: '0px',
		borderLeftWidth: '4px',
		backgroundColor: `${TOGGLE_ACTIVE} !important`,
		height: 'fit-content',
		padding: '0px 16px !important',
		'& .MuiAlert-message': {
			width: '100%',
			display: 'flex'
		},
		'& .MuiSvgIcon-root': {
			color: PURPLE
		}
	},
	btnAlertForExpiringReport: {
		padding: 0,
		marginRight: '28px',
		color: ALERT_FONT_COLOR,
		'&:hover': {
			backgroundColor: 'transparent',
			textDecoration: 'underline'
		}
	},
	customWidth: {
		fontSize: 12,
		maxWidth: 150,
		fontWeight: 400
	},
	draftProgress: {
		width: '16%',
		backgroundColor: '#FFFFFF'
	},
	shareIcon: {
		color: GREY,
		fontSize: 20,
		paddingTop: 5,
		paddingLeft: 5
	}
}));

export const StyledLinearProgress = withStyles({
	colorPrimary: {
		color: PURPLE
	}
})(LinearProgress);

export default dashboardStyles;
